import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analytics/firebaseAnalytics';

/**
 * Hook to automatically track page views on route changes
 */
export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname, {
      page_path: location.pathname,
      page_search: location.search,
      page_hash: location.hash,
    });
  }, [location]);
};

